import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Section, Sub } from './GrowthBits';
import { DEPTS } from './growthData';

export default function DeptsTab() {
  const [open, setOpen] = useState(null);
  return (
    <div data-testid="egt-tab-depts">
      <Section eyebrow="Part 05 · Department Execution Plans" title="What each department must deliver" lead="Click into a department for its responsibilities, capacity, KPIs, priorities and the risk that could stop us hitting target." />
      <Sub>Eight departments · one target</Sub>
      <div className="egt-depts">
        {DEPTS.map((d) => { const on = open === d.name; return (
          <div key={d.name} className={cn('egt-dept', on && 'open')} style={{ '--tone': d.tone }} data-testid={`egt-dept-${d.name.replace(/\W+/g, '-').toLowerCase()}`}>
            <button type="button" className="egt-dh" onClick={() => setOpen(on ? null : d.name)} aria-expanded={on}><i /><b>{d.name}</b><small>{d.roles}</small><ChevronRight className="egt-phcaret" style={{ transform: on ? 'rotate(90deg)' : undefined }} /></button>
            {on && (
              <div className="egt-db">
                <p>{d.resp}</p>
                <div className="egt-dgrid">
                  <div className="egt-dbox"><div className="egt-lab">Roles</div>{d.roles}</div>
                  <div className="egt-dbox"><div className="egt-lab">Accountable for</div>{d.acc}</div>
                </div>
                <div><div className="egt-lab">Immediate priorities</div><ul className="egt-obj">{d.pri.map((p) => <li key={p}>{p}</li>)}</ul></div>
                <div className="egt-dgrid">
                  <div className="egt-dbox"><div className="egt-lab">Key KPIs</div>{d.kpis}</div>
                  <div className="egt-dbox warn"><div className="egt-lab" style={{ color: '#ff6961' }}>Key risk</div>{d.risk}</div>
                </div>
              </div>
            )}
          </div>
        ); })}
      </div>
    </div>
  );
}
